async function getCountriesAPI() {
    try {
        const response = await fetch('/places/countries.json')
        .then((response) => response.json())
        .then((data) => {
            return data;
        });        
        return response;
    } catch (error) {
        //logoutPageReDirection(error);
        //return erroHandlingMethod(error);
        console.log(error); 
        return [];
    }
};



async function getStatesAPI() {
    try {
        const response = await fetch('/places/states.json')
        .then((response) => response.json())
        .then((data) => {
            return data;
        });        
        return response;
    } catch (error) {
        //logoutPageReDirection(error);
        //return erroHandlingMethod(error);
        console.log(error); 
        return [];
    }
};


async function getCitiesAPI() {
    try {
        const response = await fetch('/places/cities.json')
        .then((response) => response.json())
        .then((data) => {
            return data;
        });        
        return response;
    } catch (error) {
      //logoutPageReDirection(error);
      //return erroHandlingMethod(error);
      console.log(error); 
      return [];
    }
};

async function getTimeZonesAPI() {
    try {
        const response = await fetch('/places/timezones.json')
        .then((response) => response.json())
        .then((data) => {
            return data;
        });        
        return response;
    } catch (error) {
      //logoutPageReDirection(error);
      //return erroHandlingMethod(error);
      console.log(error); 
      return [];
    }
};




export { getCountriesAPI, getStatesAPI, getCitiesAPI, getTimeZonesAPI }; 